// NOTE: This file was automatically generated by a script. Do not modify this file manually.
// To regenerate this file, please use `pnpm scripts:microbootstrap-generator surveys`
// The command will generate files in the 'frontend/artifacts' folder with the list of files using collections
import { PropsWithChildren } from 'react'

import {
  CollectionBootstrapConfig,
  CollectionsBootstrap as CoreCollectionsBootstrap,
} from 'modules/core/components/CollectionsBootstrap'
import features from 'modules/core/store/collections/features'
import users from 'modules/core/store/collections/users'

import locations from 'modules/locations/store/collections/locations'
import memberships from 'modules/teams/store/collections/memberships'
import teams from 'modules/teams/store/collections/teams'

const CollectionsBootstrap = ({ children }: PropsWithChildren) => {
  /* employees manually fetched by 6 pages in this module */
  /* users manually fetched by 2 pages in this module */
  const collections: CollectionBootstrapConfig[] = [
    [features, {}] /* Referenced by 18 cases in this module */,
    [locations, {}] /* Referenced by 4 cases in this module */,
    [memberships, {}] /* Referenced by 10 cases in this module */,
    [teams, {}] /* Referenced by 12 cases in this module */,
    [users, {}] /* Referenced by 20 cases in this module */,
  ] /* Generated file 👉 artifacts/surveys-module-index.tsx-collection-dependencies-report-v2.json */

  return <CoreCollectionsBootstrap collections={collections}>{children}</CoreCollectionsBootstrap>
}

export default CollectionsBootstrap
